import {Box, Card, CardContent, Grid, Link} from "@mui/material";
import type {ReactNode} from "react";
import Typography from '@mui/material/Typography';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import ContainerCenteredGrid from '@/components/ContainerCenteredGrid/ContainerCenteredGrid.tsx';
import StatementSearchForm from '@/components/StatementSearchForm/StatementSearchForm.tsx';

const SearchStatementPage = (): ReactNode => {
    return <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Card sx={{m: 2, backgroundColor: '#eee'}}>
            <CardContent>
                <ContainerCenteredGrid sx={{p: 2, justifyContent: 'flex-start'}}>
                    <Grid sx={{justifyContent: 'center'}}>
                        <Link href="http://property.berkeley.edu" color="inherit">
                            Property Management
                        </Link>
                        <Box sx={{display: 'inline', mx: 2}}>|</Box>
                        <Link href="/search-statements" color="inherit">
                            Statement Search
                        </Link>
                    </Grid>
                    <Grid sx={{justifyContent: 'center', mt: 2}}>
                        <Typography variant='h6'>Your Search Criteria</Typography>
                    </Grid>
                    <Grid sx={{justifyContent: 'center', mt: 2}}>
                        <Typography variant='body1'>
                            To retrieve Statements of Charges, enter your search criteria and click Start Search. A
                            typical search will only require the unique portion of your Chart of Accounts (for
                            example, Fund and Dept ID).
                        </Typography>
                    </Grid>
                    <Grid sx={{justifyContent: 'center', mt: 2, width: '100%'}}>
                        <StatementSearchForm/>
                    </Grid>
                </ContainerCenteredGrid>
            </CardContent>
        </Card>
    </LocalizationProvider>;
};

export default SearchStatementPage;
